export default "__VITE_ASSET__SSXi30ce__"